import { DOCUMENT, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@environment';
import { WindowRef } from '@sb-tools/typescript/services/window-ref.service';
import { isPlatformBrowser } from '@angular/common';

declare let magicWidget: any;

@Injectable({
    providedIn: 'root',
})
export class MagicWidgetService {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private windowRef: WindowRef,
        @Inject(PLATFORM_ID) private platformId: string,
    ) {}

    init(communityName: string, widgetLanguage: 'no' | 'se' | 'da' | 'en' | 'fi') {
        const scriptElement = this.document.createElement('script') as any;
        scriptElement.async = 1;
        scriptElement.src = environment.magicWidgetUrl + '/magic-widget.js';
        this.document.body.appendChild(scriptElement);

        const config = {
            community: communityName,
            moduleMask: 2,
            initModule: 2,
            language: widgetLanguage,
            messenger: {
                home: {
                    logoDimensions: { width: '154px' },
                },
                chat: {
                    authenticationMask: 14,
                },
            },
        };
        if (isPlatformBrowser(this.platformId)) {
            (this.windowRef.nativeWindow as any).magicWidgetAsyncInit = () => {
                magicWidget.initializeAsync(config).catch((error) => {
                    console.error(error);
                });
                magicWidget.isLaunched$.subscribe((isLaunched) => {
                    console.log('widget is launched: ' + isLaunched);
                });
            };
        }
    }
}
